// components/genre/GenreOverview.jsx
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const GenreOverview = ({ data, onGenreSelect, loading }) => {
    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow p-6 col-span-2">
            <h3 className="text-lg font-semibold mb-4">Genre Overview</h3>
            <div className="h-96">
                <ResponsiveContainer>
                    <BarChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="label" angle={-45} textAnchor="end" height={70} />
                        <YAxis />
                        <Tooltip />
                        <Bar
                            dataKey="numberOfGames"
                            fill="#3B82F6"
                            onClick={(data) => onGenreSelect && onGenreSelect(data)}
                            className="cursor-pointer"
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default GenreOverview;